import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

export interface ExternalProps {
    value: string;
    text: string;
}

export class TextDropDownItem extends React.Component<ExternalProps, any> {
    constructor(props: ExternalProps) {
        super(props);
    }

    render() {
        return (
            <option value={this.props.value}>{this.props.text}</option>    
        )
    }
}

export default TextDropDownItem;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./App/findapd/components/filters/filter-dropdown-text-option.tsx